"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTHS = exports.THEMES = exports.SIZES = exports.HEIGHTS = exports.FONT_FAMILIES = void 0;
var FONT_FAMILIES = exports.FONT_FAMILIES = {
  BOLD: 'bold',
  REGULAR: 'regular'
};
var THEMES = exports.THEMES = {
  WHITE: 'white',
  PURPLE: 'purple',
  GRAY: 'gray',
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red',
  LIGHT_GREEN: 'light-green',
  LIGHT_YELLOW: 'light-yellow',
  LIGHT_RED: 'light-red',
  TRANSPARENT: 'transparent'
};
var SIZES = exports.SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  'EXTRA-MEDIUM': 'extra-medium',
  LARGE: 'large'
};
var WIDTHS = exports.WIDTHS = {
  FLUID: 'fluid'
};
var HEIGHTS = exports.HEIGHTS = {
  FLUID: 'fluid',
  INHERIT: 'inherit'
};